import styled from "styled-components";

import { useLanguage } from "../contexts/language";
import { languages } from "../constants/translation";

const Segmented = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 2px;
  border-radius: 9px;
  border: 1px solid #e5e5e5;
  background-color: #f4f4f5;
  padding: 2px;
`;

const Segment = styled.button`
  display: flex;
  align-items: center;
  gap: 5px;
  border: none;
  border-radius: 7px;
  cursor: pointer;
  padding: 5px 9px;
  font-size: 13px;
  font-weight: ${(props) => (props.$active ? 700 : 500)};
  color: ${(props) => (props.$active ? "#1a1a1a" : "#6b7280")};
  background-color: ${(props) => (props.$active ? "#c9a961" : "transparent")};
  transition: all 0.18s ease;

  @media (min-width: 480px) {
    padding: 6px 11px;
    font-size: 14px;
  }

  &:hover {
    color: #1a1a1a;
  }
`;

const Flag = styled.span`
  font-size: 14px;
  line-height: 1;
`;

export const LanguageSwitcher = (props) => {
  const { language, changeLanguage } = useLanguage();

  return (
    <Segmented role="group" aria-label="Language">
      {languages.map((lang) => {
        const isActive = lang.code === language;
        return (
          <Segment
            key={lang.code}
            type="button"
            $active={isActive}
            aria-pressed={isActive}
            aria-label={lang.name}
            onClick={() => changeLanguage(lang.code)}
          >
            <Flag aria-hidden="true">{lang.flag}</Flag>
            <span>{lang.label}</span>
          </Segment>
        );
      })}
    </Segmented>
  );
};
